import Backbone from 'backbone'
import template from './performance.hbs'
import _ from 'lodash'
import globals from 'scoreboard/components/globals'
import Radial from 'scoreboard/components/gauge/radial'
import calendars from 'scoreboard/components/calendars'
import enums from 'scoreboard/components/enums'
import LineClamp from 'scoreboard/components/line-clamp'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import { isV5 } from 'scoreboard/components/version'
import config from 'scoreboard/components/config'

var colorClasses = _.memoize(function() {
	return _.keys(enums.scoreColor).join(' ')
})

var PerformanceView = Backbone.View.extend({

	className: 'panel',

	/**
	 * @param {ScorecardNode} options.model the ScorecardNode model
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		let description = this.model.get('description')
		// If it's determined there is text (not just whitespace and carriage
		// returns), display description exactly as user inputed. Issue #27059
		if (!config.showScorecardsOverviewDescription) {
			description = null
		} else if (_.trim(description))  {
			// #26807 #26920 preserve line breaks in description
			description = escapePreserveLineBreaks(description)
		} else {
			// Otherwise, don't display the description at all.
			// Set to null incase there was a description, but it was all whitesapce.
			description = null
		}
		if (this.$el.children().length === 0) {
			this.$el.append(template({ description }))
			if (isV5()) {
				this.$('.panel-header').addClass('panel-header-transparent')
			}
			this.radial = new Radial({
				el: this.$('.radial-gauge').get(0),
				model: this.model,
				tooltipExtraClass: 'scorecards-overview-performance-non-abbreviated-tooltip'
			})
		}

		var currentScore = this.model.score(globals.periodId)
		var previousPeriod = calendars.relativePeriod(globals.periodId, -1)
		var previousPeriodId = previousPeriod && previousPeriod.id
		var previousScore = this.model.score(previousPeriodId)
		var color = (currentScore && currentScore.color) || 'gray'
		this.$el.removeClass(colorClasses()).addClass(color)

		this.radial.render({
			periodId: globals.periodId,
			currentScore: currentScore,
			previousScore: previousScore
		})

		if (isV5()) {
			if (!_.isEmpty(description)) {
				this._setupDescriptionLineClamp()
			}
		}
		this._setupListeners()

		return this
	},

	// TODO: Remove when V5 is no longer supported
	_setupDescriptionLineClamp: function() {
		if (_.isNil(this.descriptionLineClamp)) {
			this.descriptionLineClamp = new LineClamp({
				el: this.$('.description'),
				maxHeight: 80 // 80 matches height from basics.scss:.has-text-overflow
			})
			this.descriptionLineClamp.resize()
		}
	},

	_setupListeners: function() {
		if (!_.isNil(this.descriptionLineClamp)) {
			this.on('resize', () => this.descriptionLineClamp.resize())
		}
	}
})

export default PerformanceView

PerformanceView.__filename__ = 'scorecards/overview/performance.js'
